<template>
  <div class="uk-position-relative section2" uk-slideshow="animation: fade; autoplay: true; max-height: 600">

    <ul class="uk-slideshow-items">
      <li v-for="(item, index) in slideItems" :key="index">
        <img :src="item.url" alt="" uk-cover/>
      </li>
    </ul>

    <div class="uk-visible@s">
      <a class="uk-slidenav-large uk-position-center-left-out uk-position-small" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
      <a class="uk-slidenav-large uk-position-center-right-out uk-position-small" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
    </div>

    <div class="uk-position-bottom-center uk-position-small">
      <ul class="uk-thumbnav">
        <li v-for="(item, index) in slideItems" :key="index" :uk-slideshow-item="index">
          <a href="#">
            <div class="uk-cover-container">
              <canvas class="thumbnail"></canvas>
              <img :src="item.url" alt="" uk-cover/>
            </div>
          </a>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: 'PropertySectionFour',
  props: ['slideItems']
}
</script>

<style scoped>
  .section2 {
    padding-top: 80px;
  }

  @media only screen and (min-width: 1129px) {
    .thumbnail {
      height: 10vw;
      max-height: 50px;
    }
  }

  @media only screen and (max-width: 1129px) {
    .thumbnail {
      width: 40px;
    }
  }

  @media only screen and (max-width: 539px) {
    .thumbnail {
      width: 30px;
    }
  }

  @media only screen and (max-width: 449px) {
    .thumbnail {
      width: 20px;
    }
  }

  @media only screen and (max-width: 449px) {
    .thumbnail {
      width: 15px;
    }
  }
</style>
